/**
 * Utilities for extracting and normalising data refresh metadata from feature properties
 * Handles format conversion (ISO dates → DD/MM/YYYY)
 */

export const formatDateFromISO = (isoDate) => {
    if (!isoDate) {
        return null;
    }

    const date = new Date(isoDate);
    if (Number.isNaN(date.getTime())) {
        return null;
    }

    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};

/*
 * Normalise time unit to plural lowercase (e.g., 'Day' → 'days')
 */
export const normaliseTimeUnit = (unit) => {
    if (!unit) {
        return null;
    }

    const normalised = unit.toLowerCase().trim();
    return normalised.endsWith('s') ? normalised : `${normalised}s`;
};

/**
 * Extract refresh metadata from feature properties with fallback to legacy field names
 */
export const getRefreshDataFromFeature = (featureProps = {}) => {
    const refreshDate = formatDateFromISO(
        featureProps.datelastupdated ?? featureProps.systemloaddate
    );

    const refreshPeriod = featureProps.expectedrefreshperiod_period ?? featureProps.expectedrefreshperiod;

    const refreshUnits = normaliseTimeUnit(
        featureProps.expectedrefreshperiod_unitoftime ?? featureProps.expectedrefreshunits
    );

    return {
        refreshDate,
        refreshPeriod,
        refreshUnits
    };
};
